import CategoryManagement from './category-management';

export default CategoryManagement;
